import { PrankDefinition, Intensity } from './types';

const TICK_MS = 30000;
const DEGREES_PER_TICK = 0.05;
const MAX_DEGREES = 1.5;
const INTENSE_MULTIPLIER = 10;

const tiltPrank: PrankDefinition = {
  namedCode: 'tilt',
  hexCode: 'a1f0',
  create: (intensity) => {
    const speed = intensity === Intensity.INTENSE ? INTENSE_MULTIPLIER : 1;
    let degrees = 0;
    let direction = 1;

    const interval = setInterval(() => {
      degrees += DEGREES_PER_TICK * direction;
      if (degrees >= MAX_DEGREES) direction = -1;
      if (degrees <= -MAX_DEGREES) direction = 1;
      document.body.style.transform = `rotate(${degrees}deg)`;
      document.body.style.transformOrigin = 'center center';
    }, TICK_MS / speed);

    return () => {
      clearInterval(interval);
      document.body.style.transform = '';
      document.body.style.transformOrigin = '';
    };
  },
};

export default tiltPrank;
